import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component, cloneElement, createElement } from 'react';
import Button from '../Button';
import FocusGroup from '../FocusGroup';
import { ItemList, ItemListController } from '../ItemList';
import Menu from '../Menu';
import Popover from '../Popover';
import { cloneChildren, generateId } from '../utils';
import Item, { ITEM_DISPLAY_NAME } from './Item';
import Link, { LINK_DISPLAY_NAME, LINK_DATA } from './Link';

var Dropdown = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "openPopover", function (event) {
      if (_this.props.onOpen) {
        _this.props.onOpen();
      }

      _this.setState({
        isPopoverOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function (event) {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.forceOpen) {
        _this.setState({
          isPopoverOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopover", function (event) {
      if (_this.state.isPopoverOpen) {
        _this.closePopover(event);
      } else {
        _this.openPopover(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (data, _ref) {
      var node = _ref.node;

      if (_this.props.closeOnSelect) {
        _this.itemList.clearHighlightedIndex();

        _this.closePopover();

        _this.popover.focusAnchor();
      }

      if (data === LINK_DATA) {
        node.click();
      } else if (_this.props.onSelect) {
        _this.props.onSelect(data);
      }
    });

    _this.state = {
      isPopoverOpen: props.defaultOpen || props.forceOpen
    };
    _this.id = generateId('dropdown');
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        forceOpen = _this$props.forceOpen,
        closeOnSelect = _this$props.closeOnSelect,
        children = _this$props.children,
        as = _this$props.as,
        defaultOpen = _this$props.defaultOpen,
        _innerRef = _this$props.innerRef,
        keepInView = _this$props.keepInView,
        lockScrollWhileOpen = _this$props.lockScrollWhileOpen,
        matchWidths = _this$props.matchWidths,
        onClick = _this$props.onClick,
        onClose = _this$props.onClose,
        onKeyDown = _this$props.onKeyDown,
        onOpen = _this$props.onOpen,
        placement = _this$props.placement,
        popoverProps = _this$props.popoverProps,
        renderTo = _this$props.renderTo,
        triggerElement = _this$props.triggerElement,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["forceOpen", "closeOnSelect", "children", "as", "defaultOpen", "innerRef", "keepInView", "lockScrollWhileOpen", "matchWidths", "onClick", "onClose", "onKeyDown", "onOpen", "placement", "popoverProps", "renderTo", "triggerElement"]);

    var isPopoverOpen = this.state.isPopoverOpen;
    var arrowIconOnly = !restProps.icon && !restProps.title;
    var index = -1;
    return /*#__PURE__*/React.createElement(FocusGroup, {
      onBlur: this.closePopover
    }, function (_ref2) {
      var requestBlur = _ref2.requestBlur,
          setRef = _ref2.setRef;
      return /*#__PURE__*/React.createElement(ItemList, {
        ref: function ref(c) {
          return _this2.itemList = c;
        },
        onSelect: _this2.handleSelect
      }, function (_ref3) {
        var getItemByText = _ref3.getItemByText,
            moveHighlightedIndex = _ref3.moveHighlightedIndex,
            selectHighlightedItem = _ref3.selectHighlightedItem,
            setHighlightedIndex = _ref3.setHighlightedIndex,
            stringSearch = _ref3.stringSearch;
        return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverProps, {
          as: Menu,
          ref: function ref(component) {
            _this2.popover = component;
          },
          innerRef: function innerRef(node) {
            setRef(_this2.id + "-popover")(node);
          },
          role: "menu",
          tabIndex: -1,
          elevation: 2,
          display: Boolean(restProps.spinner) ? 'none' : undefined,
          onBlur: requestBlur,
          matchWidths: matchWidths,
          keepInView: keepInView,
          lockScrollWhileOpen: lockScrollWhileOpen,
          placement: placement,
          renderTo: renderTo,
          open: isPopoverOpen,
          onRequestClose: function onRequestClose() {
            _this2.closePopover();

            _this2.popover.focusAnchor();
          },
          anchorElement: function anchorElement(anchorProps) {
            return /*#__PURE__*/React.createElement(ItemListController, null, function (_ref4) {
              var _objectSpread2;

              var getHighlightedItemId = _ref4.getHighlightedItemId;

              var triggerProps = _objectSpread((_objectSpread2 = {
                innerRef: function innerRef(node) {
                  var _anchorProps$innerRef;

                  if (typeof anchorProps.innerRef === 'function') {
                    anchorProps.innerRef(node);
                  } else if ((_anchorProps$innerRef = anchorProps.innerRef) != null && _anchorProps$innerRef.current) {
                    anchorProps.innerRef.current = node;
                  }

                  setRef(_this2.id + "-button")(node);

                  if (_innerRef) {
                    _innerRef(node);
                  }
                },
                'aria-activedescendant': getHighlightedItemId(),
                'aria-owns': getHighlightedItemId(),
                'aria-haspopup': true,
                'aria-expanded': isPopoverOpen
              }, _objectSpread2[arrowIconOnly ? 'icon' : 'iconRight'] = {
                name: isPopoverOpen ? 'arrow-up' : 'arrow-down',
                size: 'sm'
              }, _objectSpread2.title = arrowIconOnly ? 'arrow down' : restProps.title, _objectSpread2.tabIndex = 0, _objectSpread2.cursor = 'pointer', _objectSpread2.onBlur = requestBlur, _objectSpread2.onClick = function onClick() {
                _this2.togglePopover();

                if (!isPopoverOpen) {
                  _this2.popover.focusAnchor();
                }
              }, _objectSpread2.onKeyDown = function onKeyDown(event) {
                anchorProps.onKeyDown(event);

                switch (event.key) {
                  case 'ArrowUp':
                    event.preventDefault();

                    if (isPopoverOpen) {
                      moveHighlightedIndex(-1);
                    } else {
                      _this2.openPopover();

                      setTimeout(function () {
                        moveHighlightedIndex(-1);
                      });
                    }

                    break;

                  case 'ArrowDown':
                    event.preventDefault();

                    if (isPopoverOpen) {
                      moveHighlightedIndex(1);
                    } else {
                      _this2.openPopover();

                      setTimeout(function () {
                        moveHighlightedIndex(1);
                      });
                    }

                    break;

                  case 'Enter':
                    if (isPopoverOpen) {
                      event.preventDefault();
                      selectHighlightedItem();
                    }

                    break;

                  case ' ':
                    event.preventDefault();

                    _this2.togglePopover();

                    break;

                  default:
                    stringSearch(event).then(function (text) {
                      var item = getItemByText(text);

                      if (item) {
                        setHighlightedIndex(item.props.index);
                      }
                    });
                }
              }, _objectSpread2), restProps);

              if ( /*#__PURE__*/React.isValidElement(triggerElement)) {
                return /*#__PURE__*/cloneElement(triggerElement, triggerProps);
              } else {
                return /*#__PURE__*/createElement(triggerElement, triggerProps);
              }
            });
          }
        }), cloneChildren(children, function (child) {
          if (child.type.displayName === ITEM_DISPLAY_NAME || child.type.displayName === LINK_DISPLAY_NAME) {
            index++;
            return {
              index: index
            };
          } else {
            return {};
          }
        }));
      });
    });
  };

  return Dropdown;
}(Component);

_defineProperty(Dropdown, "Item", Item);

_defineProperty(Dropdown, "Link", Link);

_defineProperty(Dropdown, "defaultProps", {
  triggerElement: Button,
  closeOnSelect: true,
  defaultOpen: false
});

export default Dropdown;